import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import type { RootState } from 'store';

import tickmarkImg from 'img/logos/tickmark.svg';

import { AuthActions } from 'common/auth/actions';
import { UserStatusEnum, UserType } from 'common/graphql/types';
import { CISecondaryButton } from 'common/viewcomp/forms/buttons';

export const PasswordUpdated = () => {
    const { t } = useTranslation('auth');
    const auth = useSelector((state: RootState) => state.auth);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const confirm = () => {
        if (auth.activeUser?.status === UserStatusEnum.Active || auth.activeUser?.userType !== UserType.Patient) {
            localStorage.setItem('activeUser', JSON.stringify(auth.activeUser));
            dispatch(AuthActions.logoutRequest());
        } else {
            navigate('/');
        }
    };

    return (
        <div id="login_content">
            <div>
                <div className="tick_mark">
                    <img src={tickmarkImg} alt="" />
                </div>
                <h1 className="header" id="pwd_success">
                    {t('password_form.password_update_success')}
                </h1>
                <CISecondaryButton
                    className="submit_button"
                    type="submit"
                    id="confirm_backButton"
                    fullWidth
                    onClick={confirm}
                >
                    {t('forgotuser.back_login')}
                </CISecondaryButton>
            </div>
        </div>
    );
};
